import { EColors, EFonts } from 'libs/styles/styling';
import { useEffect, useState } from 'react';
import styled from 'styled-components/macro';

interface Props {
    label: string;
    value: string;
    autoComplete?: string;
    autoFocus?: boolean;
    placeholder?: string;
    type?: string;
    onChange?: (value: string) => void;
    onBlur?: () => void;
    className?: string;
}

export const TextInput = (props: Props): JSX.Element => {
    const [value, setValue] = useState<string>(props.value);

    useEffect(() => {
        if (props.value !== value) {
            setValue(props.value);
        }
    }, [props.value]);

    return (
        <S_TextInput className={props.className}>
            {props.label && <S_Label>{props.label}</S_Label>}
            <S_Input
                value={value}
                autoComplete={props.autoComplete}
                autoFocus={props.autoFocus}
                onChange={(e) => {
                    setValue(e.target.value);
                    if (props.onChange) {
                        props.onChange(e.target.value);
                    }
                }}
                type={props.type ?? 'text'}
                onBlur={props.onBlur}
            />
        </S_TextInput>
    );
};

export const S_TextInput = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const S_Input = styled.input`
    border: 1px solid ${EColors.GREY4};
    background-color: #485089;
    border-radius: 7px;
    font-family: ${EFonts.Regular};
    padding: 15px 20px;
    font-size: 15px;
    color: white;
    min-width: 45px;
    resize: none;
    outline: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    &:focus {
        border: 1px solid ${EColors.ACC2_A};
    }
`;

const S_Label = styled.div`
    color: white;
    font-size: 16px;
    margin: 0 0 12px 0;
    font-family: ${EFonts.Medium};
`;
